import axios from './axios';
import {
  Project,
  ProjectCreate,
  ProjectUpdate,
  ProjectWithCount,
  ProjectUserRoleMapEntry,
} from '../types/project';

const BASE_URL = '/projects';

interface GetProjectsParams {
  skip?: number;
  limit?: number;
  status?: boolean;
  search?: string;
  year?: number;
  order_by?: 'code' | 'name' | 'created_on' | 'status' | 'issues_count';
  order?: 'asc' | 'desc';
}

export const projectApi = {
  getProjects: async (params?: GetProjectsParams) => {
    const response = await axios.get<Project[]>(BASE_URL, { params });
    return response.data;
  },

  getProject: async (id: number) => {
    const response = await axios.get<ProjectWithCount>(`${BASE_URL}/${id}`);
    return response.data;
  },

  createProject: async (data: ProjectCreate) => {
    const response = await axios.post<Project>(BASE_URL, data);
    return response.data;
  },

  updateProject: async (id: number, data: ProjectUpdate) => {
    const response = await axios.put<Project>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  deleteProject: async (id: number) => {
    await axios.delete(`${BASE_URL}/${id}`);
  },

  getProjectUserRoleMap: async () => {
    const response = await axios.get<ProjectUserRoleMapEntry[]>(`${BASE_URL}/user-role-map`);
    return response.data;
  },
};
